export function getLinkText(link: string) {
  try {
    return decodeURI(link)
  } catch (e) {
    return link
  }
}

export function addProtocolToUrl(link: string) {
  return `https://${link}`
}
